import { render } from "./Snackbar.vue?vue&type=template&id=23f49b1c"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=23f49b1c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__